import React from 'react';
import {useTranslation} from 'react-i18next';
import {Dialog, DialogContent, Button, DialogFooter, Theme} from '@taopix/taopix-design-system';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import {UserInterfaceActions} from '../Context/UserInterface/UserInterfaceActionTypes';
import {useUserFlowState} from '../Context/UserFlow/UserFlowContext';
import {UserFlowStep} from '../../Facade/UserFlow/BaseUserFlow';
import {UserFlowType} from '../../Facade/UserFlow/UserFlowFacade';

export type LogoutConfirmationDialogProps = {
  open: boolean;
};

const LogoutConfirmationDialog = ({open}: LogoutConfirmationDialogProps) => {
  const {t} = useTranslation(['*', 'dialogs']);
  const ui = useUiState();
  const userFlow = useUserFlowState();

  const onLogout = () => {
    // set userFlow to logout
    userFlow.setCurrentStep(`${UserFlowStep.Auth}.${UserFlowStep.Logout}`);
  };

  const onCancel = () => {
    userFlow.deactivateUserFlow(UserFlowType.Auth);
  };

  return (
    <Dialog
      open={open}
      theme={'tpx-theme-dialogs'}
      themeTip="Dialogs"
      title={t('dialogs:str_TitleLogoutConfirmation', {defaultValue: 'Logout Confirmation'})}
      showTitle={false}
      aria-live="assertive"
    >
      <DialogContent>
        <Theme element={'p'} className={'mb-md'}>
          {t('*:str_MessageSureYouWantToLogOut')}
        </Theme>
      </DialogContent>
      <DialogFooter isSmallScreen={ui.state.isSmallScreen}>
        <Button
          label={t('*:str_ButtonCancel')}
          buttonStyle={'secondary'}
          onClick={() => onCancel()}
        />
        <Button label={t('*:str_LabelLogout')} onClick={() => onLogout()} />
      </DialogFooter>
    </Dialog>
  );
};

export default LogoutConfirmationDialog;
